import { SetAppErrorActionType, SetAppStatusActionType } from './../../app/app-reducer';
import { Dispatch } from 'redux';
import { setAppErrorAC, setAppStatusAC } from "../../app/app-reducer"

export const handleServerNetworkError = (message: string, dispatch: Dispatch<SetAppErrorActionType | SetAppStatusActionType>) => {
  dispatch(setAppErrorAC(message ? {error: message, color:'error'} : {error: 'Some error occurred', color:'error'}))
  dispatch(setAppStatusAC({status:'failed'}))
}

export const handleRequestResponseError = (error: any, dispatch: Dispatch) => {
  if (error.response) {
    const status = error.response.status
    if (status === 401) {
      dispatch(setAppErrorAC({ error: "Your session token is expired or  is no longer active!", color: 'error' }))
      //dispatch(logoutTC())
    } else {
      dispatch(setAppErrorAC({ error: `Something happened... Server response: ${error.response.status}`, color: 'error' }))
    }
  } else if (error.request) {
    dispatch(setAppErrorAC({ error: 'Server is not available', color: 'error' }))
  } else {
    handleServerNetworkError(error.message, dispatch)
  }
}
